export default __webpack_public_path__ + "static/media/lines-3d.c48fd00e.svg";